<template>
  <div class="payment-options">
    <h2>Make your Deposit NOW with:</h2>
    <div class="buttons">
      
      <!-- Vodacom Instant -->
      <DepositMethodButton
        method-name="vodacom"
        method-class="vodacom"
        icon="/icons/vodacom.png"
        button-text="Vodacom Instant"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!-- Ecocash -->
      <DepositMethodButton
        method-name="ecocash"
        method-class="ecocash"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      >
        <div class="ecocash-wallet">
          <div class="ecocash-banner">
            <span class="eco">Eco</span><span class="cash">Cash</span>
          </div>
        </div>
      </DepositMethodButton>

      <!-- Debit/Credit Card -->
      <DepositMethodButton
        method-name="nedbank"
        method-class="nedbank"
        icon="/icons/visa-master.png"
        button-text="Debit/Credit Card"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!-- Vodacom Merchant -->
      <DepositMethodButton
        method-name="vodacom-merchant"
        method-class="vodacom"
        icon="/icons/vodacom.png"
        button-text="Vodacom Merchant"
        :text-style="{ paddingLeft: '10px' }"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!-- MyWallet -->
      <DepositMethodButton
        method-name="mywallet"
        method-class="mywallet"
        icon="/icons/mywallet.webp"
        button-text="MyWallet"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      />

      <!-- OTT Voucher -->
      <!-- <DepositMethodButton
        method-name="ottvoucher"
        method-class="ottvoucher"
        icon="/icons/ottvoucher.png"
        button-text="OTT Voucher"
        @click="handleMethodClick"
        @info-click="handleInfoClick"
      /> -->

      <!-- Help/Thuso -->
      <div style="margin-top: 15px;">
        <DepositMethodButton
          method-name="help"
          method-class="help"
          button-text="Thuso / Help"
          :text-style="{ paddingLeft: '10px' }"
          :show-info="false"
          @click="handleMethodClick"
        />
      </div>
      
    </div>
  </div>
</template>

<script>
import DepositMethodButton from './DepositMethodButton.vue';

export default {
  name: 'DepositMethodsGridLesotho',
  components: {
    DepositMethodButton
  },
  props: {
    username: {
      type: String,
      default: ''
    }
  },
  emits: ['method-selected', 'info-requested'],
  methods: {
    handleMethodClick(methodName) {
      this.$emit('method-selected', methodName);
    },
    handleInfoClick(methodName) {
      this.$emit('info-requested', methodName);
    }
  }
};
</script>

<style scoped>
.payment-options {
  padding: 30px 16px 24px;
  text-align: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  box-sizing: border-box;
  overflow: hidden;
}

.payment-options h2 {
  font-size: 28px;
  font-weight: 700;
  color: #1a2332;
  margin-bottom: 40px;
  letter-spacing: -0.5px;
}

.buttons {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 120px));
  gap: 24px;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px 0;
  justify-content: center;
  justify-items: center;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .buttons {
    grid-template-columns: repeat(auto-fit, minmax(120px, 120px));
    gap: 20px;
  }

  .payment-options h2 {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .buttons {
    grid-template-columns: repeat(2, minmax(120px, 120px));
    gap: 16px;
  }
}

.blue {
  color: blue;
}

.red {
  color: red;
}

/* EcoCash wallet design */
.ecocash-wallet {
  position: relative;
  width: 86px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ecocash-banner {
  background: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 900;
  letter-spacing: -0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 1;
  white-space: nowrap;
}

.eco {
  color: #2e7d32;
}

.cash {
  color: #c62828;
}

</style>
